import {
    paramDestDs,
    paramDestPath,
    paramExcludeSourceRoot,
    paramValue,
} from '../constants/parameterNames';
import {
    typeBoolean,
    typeDataSource,
    typeXPath,
} from '../constants/parameterTypes';
import { failure, success } from '../helpers/commandResult';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';

const $ = window.jQuery;

const requiredParameters = [
    {
        name: paramDestPath,
        description: 'Destination path',
        type: typeXPath,
        dsParentName: paramDestDs,
    },
    {
        name: paramValue,
        description: 'XML value to set',
    },
];
const optionalParameters = [
    {
        name: paramDestDs,
        description: 'Destination data source',
        type: typeDataSource,
    },
    {
        name: paramExcludeSourceRoot,
        description:
            '(boolean) - When true, omits the root element of the source node from the inserted XML and only inserts its contents',
        type: typeBoolean,
    },
];

const description =
    'Allows setting the XML content of a node based on a string.';

const copyNodes = (xmlNodes) => xmlNodes.map((n) => n.cloneNode(true));

const setXmlValueAsync = async (destNodes, xmlNodes) => {
    for (const destNode of destNodes) {
        await destNode.setContentAsync(copyNodes(xmlNodes));
    }
};

// Parses xmlString and returns the root of the parsed XML.
// If xmlString represents multiple nodes/elements, the result will be returned as a pseudo-root: an element named <n>
function parseXmlToRoot(xmlString) {
    try {
        return $.parseXML(xmlString);
    } catch (e) {
        //Parse xml in a parent node to avoid multiple root node issue
        return $.parseXML('<n>' + xmlString + '</n>').documentElement;
    }
}

// returns an array of all of the child-nodes of the child-nodes under root
function aggregateChildNodes(nodes) {
    var allNodes = nodes
        .filter((node) => node.childNodes)
        .map((node) => Array.from(node.childNodes));

    return Array.prototype.concat.apply([], allNodes);
}

function getXmlNodes(xmlString, excludeRoot) {
    var parsedResult = parseXmlToRoot(xmlString);
    var childNodes = Array.prototype.slice.call(parsedResult.childNodes);

    return excludeRoot ? aggregateChildNodes(childNodes) : childNodes;
}

const executeAsync = async ({ dataSources, parameters }) => {
    var destPath = getParamValue(parameters, paramDestPath);
    var value = getParamValue(parameters, paramValue);
    var destDs = getParamValue(parameters, paramDestDs);
    var excludeRoot = getBoolParamValue(parameters, paramExcludeSourceRoot);

    var xmlNodes = getXmlNodes(value, excludeRoot);

    var destSource = getDataSource(dataSources, destDs);
    var destNodes = destSource.selectNodes(destPath);

    try {
        await setXmlValueAsync(destNodes, xmlNodes);

        return success();
    } catch (e) {
        return failure(
            'Failed to set the XML to the destination node(s): ' + e.message,
        );
    }
};

const SetXml = {
    description,
    executeAsync,
    requiredParameters,
    optionalParameters,
};

export default SetXml;
